import EColors from 'enums/EColors';
import EScoreType from 'enums/EScoreType';
import React from 'react';
import { Rect, Text, Group, Line } from 'react-konva';

export default function Score(props: any) {
  let fix = props.Scores.length === 1 ? 0.8 : 0.5;
  if (props.totalScores > 2) {
    fix = 0.8;
  }

  const lineHeight = props.Scores.length === 1 ? 1 : 3;
  const fontSize = Math.round(props.height * fix);
  const isAutoManual =
    props.scoreType === EScoreType.Auto || props.scoreType === EScoreType.Manual;
  const fillColor = isAutoManual ? props.color : EColors.White;
  const strokeFactor = (fontSize * 0.2) / 2 / props.scale;
  const isInherOrAutoInher =
    props.scoreType == EScoreType.Inherited ||
    props.scoreType == EScoreType.InheritedAuto;
  const isAutoOrAutoInher =
    props.scoreType == EScoreType.Auto || props.scoreType == EScoreType.InheritedAuto;
  const txtColor = isAutoManual ? props.textcolor : EColors.Black;
  const xValue = isAutoManual ? props.x : props.x + strokeFactor;
  const yValue = isAutoManual ? props.y : props.y + strokeFactor;
  const width = isAutoManual ? props.width : props.width - strokeFactor * 2;
  const height = isAutoManual ? props.height : props.height - fontSize * 0.2;
  const aFontSize = isAutoManual ? fontSize * 0.9 : fontSize * 0.8;

  function getTextYValue(key) {
    if (isInherOrAutoInher) {
      return yValue + strokeFactor * 0.6;
    }
    let value;
    switch (key) {
      case 'g':
      case 'q':
      case 'y':
      case 'p':
        value = yValue - fontSize * 0.1;
        break;
      default:
        value = yValue + fontSize * 0.1;
        break;
    }
    return value;
  }
  const textYValue = getTextYValue(props.Scores);
  const strokeForRect = isInherOrAutoInher && props.color ? props.color : '';

  return (
    <Group id="score-group-component">
      <Rect
        id="score-rect-component"
        x={xValue / props.scale}
        y={yValue / props.scale}
        width={width / props.scale}
        height={height / props.scale}
        fill={fillColor}
        stroke={strokeForRect}
        strokeWidth={(fontSize * 0.2) / props.scale}
      />
      {isAutoOrAutoInher && (
        <Line
          id="score-line-component"
          x={0}
          y={0}
          points={[
            xValue / props.scale,
            yValue / props.scale,
            (xValue + width * 0.45) / props.scale,
            yValue / props.scale,
            xValue / props.scale,
            (yValue + height * 0.45) / props.scale,
          ]}
          fill={'black'}
          closed={true}
        />
      )}
      <Text
        id="score-text-component"
        x={xValue / props.scale}
        y={textYValue / props.scale}
        width={width / props.scale}
        height={height / props.scale}
        fontSize={aFontSize / props.scale}
        verticalAlign="middle"
        align="center"
        textAnchor="middle"
        text={props.Scores}
        fill={txtColor}
        lineHeight={lineHeight / props.scale}
        tooltipInfo={props.toolTipText}
        fontFamily={'Roboto'}
        fontStyle={'700'}
      />
    </Group>
  );
}
